import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-right",
  "use": "icon-chevron-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-chevron-right\"><defs><style type=\"text/css\"></style></defs><path d=\"M353.834667 737.834667a42.666667 42.666667 0 0 0 60.330666 60.330666l256-256a42.666667 42.666667 0 0 0 0-60.330666l-256-256a42.666667 42.666667 0 0 0-60.330666 60.330666L579.669333 512l-225.834666 225.834667z\" p-id=\"2155\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol